import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";

function Signup() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");

  useEffect(() => {
    if (sessionStorage.getItem("isLoggedIn") === "true") {
      navigate("/");
    }
  }, [navigate]);

  const handleSignup = (e) => {
    e.preventDefault();

    if (!email || !password || !confirmPass) {
      toast.error("Please fill all fields");
      return;
    }

    if (password !== confirmPass) {
      toast.error("Passwords do not match");
      return;
    }

    sessionStorage.setItem("userEmail", email);
    sessionStorage.setItem("isLoggedIn", "true");

    toast.success("Account created successfully!");
    navigate("/");
  };

  return (
    <div className="signup-section">
      <div className="signup-card-wrapper">
        {/* LEFT PANEL */}
        <div className="signup-info">
          <h2 style={{ color: "white" }}>Create Your Account</h2>
          <p style={{ color: "white" }}>
            Register now to unlock faster checkout, saved carts, order tracking
            and personalized recommendations.
          </p>
          <img
            src="/assets/img/normal/register-illustration.svg"
            alt="signup"
          />
        </div>

        {/* RIGHT PANEL */}
        <div className="signup-form-card">
          <h3>Sign Up</h3>
          <p className="form-sub">Fill in your details to get started.</p>

          <form onSubmit={handleSignup}>
            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                placeholder="your@example.com"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Re-enter password"
                className="input"
                value={confirmPass}
                onChange={(e) => setConfirmPass(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-signup">
              Create Account
            </button>
          </form>

          <p className="login-text">
            Already a member? <Link to="/login-now">Login</Link>
          </p>
        </div>
      </div>

      {/* INLINE STYLES */}
      <style>{`
        .signup-section {
          min-height: 100vh;
          background: linear-gradient(135deg, #eef3ff, #dce9ff);
          display:flex;
          justify-content:center;
          align-items:center;
          padding: 20px;
        }

        .signup-card-wrapper {
          width: 900px;
          background: white;
          border-radius: 18px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.08);
          display: flex;
          overflow: hidden;
        }

        /* LEFT SIDE */
        .signup-info {
          flex: 1;
          background: #0b61d6;
          padding: 45px 35px;
          color: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .signup-info h2 {
          font-size: 32px;
          font-weight: 800;
          margin-bottom: 10px;
        }

        .signup-info p {
          font-size: 15px;
          opacity: 0.9;
          line-height: 1.6;
          margin-bottom: 25px;
        }

        .signup-info img {
          width: 78%;
          max-width: 330px;
          margin-top: auto;
        }

        /* RIGHT FORM SIDE */
        .signup-form-card {
          flex: 1;
          padding: 40px 35px;
        }

        .signup-form-card h3 {
          font-size: 28px;
          font-weight: 700;
          color: #222;
        }

        .form-sub {
          color: #666;
          margin-bottom: 24px;
        }

        .form-group {
          margin-bottom: 20px;
        }

        .form-group label {
          font-size: 14px;
          font-weight: 600;
          display: block;
          margin-bottom: 6px;
        }

        .input {
          width: 100%;
          padding: 13px 14px;
          border-radius: 10px;
          border: 1px solid #ccc;
          font-size: 15px;
          outline: none;
          transition: 0.25s;
        }

        .input:focus {
          border-color: #0b61d6;
          box-shadow: 0 0 0 3px rgba(11, 97, 214, 0.18);
        }

        .btn-signup {
          width: 100%;
          background: #0b61d6;
          padding: 14px;
          border-radius: 10px;
          color: white;
          border: none;
          cursor: pointer;
          font-size: 16px;
          font-weight: 700;
          transition: 0.3s;
          margin-top: 10px;
        }

        .btn-signup:hover {
          background: #084eb7;
        }

        .login-text {
          margin-top: 18px;
          font-size: 14px;
          color: #555;
        }

        .login-text a {
          color: #0b61d6;
          font-weight: 700;
          text-decoration: none;
        }

        .login-text a:hover {
          text-decoration: underline;
        }

        @media (max-width: 900px) {
          .signup-card-wrapper {
            flex-direction: column;
            width: 100%;
          }

          .signup-info img {
            display: none;
          }
        }

      `}</style>
    </div>
  );
}

export default Signup;
